import { ProductTile } from 'components/ProductTile';
import { FC, useMemo } from 'react';
import { ProductListingProps, Styled, Reload } from '.';
import { useI18n } from 'contexts/i18n';
import { usePromotionList } from 'reactQuery/queries';
import { useRetrieveDsoDiscounts } from 'reactQuery/queries/dso/useRetrieveDsoDiscounts';
import { LoadingSpinner } from 'components/core';
import { useInfiniteScroll } from 'utils/hooks';
import { useLoggedInUserTypeStore } from 'store';

const ProductListing: FC<ProductListingProps> = ({ productList }) => {
  const i18n = useI18n();
  const { data: offers } = usePromotionList();
  const loggedInUserType = useLoggedInUserTypeStore(state => state.userType);
  const isDso = loggedInUserType === 'dso';
  const { data: dsoDiscounts } = useRetrieveDsoDiscounts({
    enabled: !!isDso,
  });

  const lastElementRef = useInfiniteScroll(
    productList.isLoading,
    productList.isFetching,
    productList.hasNextPage as boolean,
    productList.fetchNextPage
  );

  const flattenedData = useMemo(
    () =>
      productList.data
        ? productList.data?.pages.flatMap(item => item?.products ?? [])
        : [],
    [productList.data]
  );

  if (productList.isError) {
    return <Reload productList={productList} />;
  }

  const isFilteringProducts =
    productList.isFetching && !productList.isFetchingNextPage;

  return (
    <Styled.ProductListingContainerWithFilters>
      <Styled.ProductListingContainer>
        {isFilteringProducts && (
          <Styled.Overlay isFetching={isFilteringProducts}>
            <LoadingSpinner />
          </Styled.Overlay>
        )}
        {flattenedData &&
          flattenedData.map((product, index) => {
            return (
              <div key={product.id}>
                <ProductTile
                  product={product}
                  isLoading={productList.isLoading}
                  doctorPromotionList={offers}
                  dsoPromotionList={dsoDiscounts}
                />
                {flattenedData.length - 1 === index && (
                  <Styled.FetchMoreSection
                    ref={lastElementRef}
                  ></Styled.FetchMoreSection>
                )}
                {flattenedData.length - 1 === index &&
                  productList.isFetchingNextPage && (
                    <Styled.FetchMoreLoader>
                      <LoadingSpinner />
                    </Styled.FetchMoreLoader>
                  )}
              </div>
            );
          })}

        {flattenedData.length === 0 &&
          !productList.isLoading &&
          !productList.isFetching && (
            <Styled.NoProductsFound>
              {i18n['No Products found.']}
            </Styled.NoProductsFound>
          )}
      </Styled.ProductListingContainer>
    </Styled.ProductListingContainerWithFilters>
  );
};

export default ProductListing;
